module.exports = __webpack_public_path__ + "media/packs/images/flags/CG-cfcd93a0477d9f77fdb4749612275a31.svg";